// Vendor imports
const _ = require('lodash')
// Shared imports
const nameUtils = require('shared/name-utils')
// Client lib imports
const { send: ajax } = require('client/lib/request')
const businessEvents = require('client/lib/business-events')

async function extractArticleFromUrl({ url, pageContext }) {
  const extractResult = await ajax({
    url: '/api/v0.1/extract',
    method: 'post',
    data: {
      url,
      'page_context': pageContext
    }
  })
  try {
    const articleResult = await ajax({
      url: `/api/v0.2/url/${extractResult.hash}`
    })
    return articleResult.url
  } catch (err) {
    // Allow blocked URLs to be added
    return {
      ..._.pick(extractResult, [
        'md5image', 'image', 'hostname',
        'url', 'url_id', 'hash', 'count'
      ]),
      title: extractResult.title || extractResult.url,
      submittedUrl: extractResult['original_url'],
      timestamp: Date.now()
    }
  }
}

async function fetchCollections(urlId) {
  const result = await ajax({
    url: '/api/v0.1/mixes/all',
    method: 'post',
    data: { 'url_id': urlId }
  })
  return [
    result.initial,
    ...result.recommended,
    ...result.existing
  ]
}

async function createCollection({ collection, pageContext }) {
  const { name, recommended = false } = collection
  const cleanName = nameUtils.cleanName(name).trim()
  if (!nameUtils.isValidMixName(cleanName)) {
    throw new Error('Invalid collection name')
  }
  const result = await ajax({
    url: '/api/v0.1/mixes',
    method: 'post',
    data: {
      name: cleanName,
      description: '',
      recommended,
      'page_context': pageContext
    }
  })
  await businessEvents.trackSegment('create-mix', {
    name: result.name,
    'mix_id': result.id
  }, {
    pageContext
  })
  return result
}

async function addToCollection({ urlId, collectionId, pageContext }) {
  const result = await ajax({
    url: `/api/v0.2/mix/url/${collectionId}`,
    method: 'post',
    data: {
      'url_id': urlId,
      'page_context': pageContext
    }
  })
  await businessEvents.trackSegment('add-url-to-mix', {
    mixId: collectionId,
    'url_id': urlId
  }, {
    pageContext
  })
  return result
}

async function removeFromCollection({ urlId, collectionId, pageContext }) {
  const result = await ajax({
    url: `/api/v0.2/mix/url/${collectionId}`,
    method: 'delete',
    data: {
      'url_id': urlId,
      'page_context': pageContext
    }
  })
  await businessEvents.trackSegment('remove-url-from-mix', {
    mixId: collectionId,
    'url_id': urlId
  }, {
    pageContext
  })
  return result
}

async function addToMixedCollection({ urlId, pageContext }) {
  const result = await ajax({
    url: `/api/v0.2/mix/url/mixed`,
    method: 'post',
    data: {
      'url_id': urlId,
      'page_context': pageContext
    }
  })
  await businessEvents.trackSegment('add-url-to-mix', {
    mixId: result.mixId,
    'url_id': urlId
  }, {
    pageContext
  })
  return result
}

async function removeFromMixedCollection({ urlId, pageContext }) {
  const result = await ajax({
    url: `/api/v0.2/mix/url/mixed`,
    method: 'delete',
    data: {
      'url_id': urlId,
      'page_context': pageContext
    }
  })
  await businessEvents.trackSegment('remove-url-from-mix', {
    mixId: result.mixId,
    'url_id': urlId
  }, {
    pageContext
  })
  return result
}

module.exports = {
  extractArticleFromUrl,
  fetchCollections,
  createCollection,
  addToCollection,
  addToMixedCollection,
  removeFromCollection,
  removeFromMixedCollection
}
